export const AGENT_TARGET_AGREEMENT_NAME = 'field:agreementName';
export const AGENT_TARGET_EFFECTIVE_DATE = 'field:effectiveDate';
export const AGENT_TARGET_NET_TERMS = 'field:netTerms';
export const AGENT_TARGET_EXPIRATION_DATE = 'field:expirationDate';
export const AGENT_TARGET_INTRODUCTORY_MESSAGE = 'field:introductoryMessage';
export const AGENT_TARGET_CREDIT_CARD_FEES_PAID_BY = 'field:creditCardFeesPaidBy';
export const AGENT_TARGET_REQUIRE_PAYMENT_METHOD = 'field:requirePaymentMethod';
export const AGENT_TARGET_REQUIRE_CLIENT_PAYMENT_APPROVAL = 'field:requireClientPaymentApproval';
export const AGENT_TARGET_AMENDMENTS_APPROVAL_METHOD = 'field:amendmentsApprovalMethod';
export const AGENT_TARGET_OUT_OF_SCOPE_CHARGES_APPROVAL_METHOD = 'field:outOfScopeChargesApprovalMethod';
export const AGENT_TARGET_AGREEMENT_NOTE = 'field:agreementNote';
export const AGENT_TARGET_LEGAL_TERMS = 'field:legalTerms';
export const agentTargetForService = (serviceId)=>"service:".concat(serviceId);
export const agentTargetForBundle = (bundleId)=>"bundle:".concat(bundleId);
export const agentTargetForContact = (contactId)=>"contact:".concat(contactId);
export const isContactTargetToken = (token)=>token.startsWith('contact:');
export const AGREEMENT_SETTINGS_TARGETS = new Set([
    AGENT_TARGET_AMENDMENTS_APPROVAL_METHOD,
    AGENT_TARGET_OUT_OF_SCOPE_CHARGES_APPROVAL_METHOD,
    AGENT_TARGET_LEGAL_TERMS,
    AGENT_TARGET_AGREEMENT_NOTE
]);
export const PAYMENT_SETTINGS_TARGETS = new Set([
    AGENT_TARGET_NET_TERMS,
    AGENT_TARGET_CREDIT_CARD_FEES_PAID_BY,
    AGENT_TARGET_REQUIRE_PAYMENT_METHOD,
    AGENT_TARGET_REQUIRE_CLIENT_PAYMENT_APPROVAL
]);
